// src/config/config.ts
export const API_URL = '/api';
export const API_URL_FORMDATA = '/api/formdata';
export const API_HOST = 'http://localhost:3000';

export const API_LOGIN = API_URL + '/login/login';
export const API_LOGOUT = API_URL + '/login/logout';
export const API_CAMBIAR_PASSWORD = API_URL + '/login/cambiopassword';
export const API_GET_CONFIG_USER = API_URL + '/configUser/getconfiguser';
export const API_SAVE_CONFIG_USER = API_URL + '/configUser/saveconfiguser';
export const API_GET_USERMENU = API_URL + '/usuario/usermenu';
export const API_STRUCTURE = API_URL + '/env/modelstructure?tabla=';
export const API_PERFIL = API_URL + '/perfil';
export const API_EMPRESA = API_URL + '/empresa';
export const API_USUARIO_PERFIL_EMPRESA = API_URL + '/usuarioperfilempresa';
export const API_ISADMIN = API_URL + '/isuseradmin';
export const API_USUARIO_SELF = API_URL + '/usuarioself';
export const API_PERFIL_MENU = API_URL + '/perfilmenu';
export const API_MODULOS_ACTIVOS = API_URL + '/usuario/modulosactivos';

export const API_ADMINISTRACION: { [key: string]: string } = {

  //GENERAL
  CALENDARIOFESTIVO: API_URL + '/calendariofestivo',
  TERCEROTIPO: API_URL + '/tercerotipo',
  TELEFONOTIPO: API_URL + '/telefonotipo',
  DIRECCIONTIPO: API_URL + '/direcciontipo',
  PAIS: API_URL + '/pais',
  PROVINCIA: API_URL + '/provincia',
  DOCUMENTOTIPO: API_URL + '/documentotipo',
  CLIENTE: API_URL + '/cliente',
  CARTERA: API_URL + '/cartera',
  MOVDEUDATIPO: API_URL + '/movdeudatipo',
  MAILTIPO: API_URL + '/mailtipo',
  PLANTILLA: API_URL + '/plantilla',
  EMAILSERVERCONFIG: API_URL + '/emailserverconfig',
  PLANTILLAMAIL: API_URL + '/plantillamail',
  REPORTS: API_URL + '/reports',
  REPORTSREGISTRY : API_URL + '/reportsregistry',
  REPORTCOLUMNS : API_URL + '/reportcolumns',
  REPORTFILTERS : API_URL + '/reportfilters',
  RUNREPORT : API_URL + '/runreport',
  EXPORTREPORTCSV : API_URL + '/exportreportcsv',

  //PLANTILLAS DOCX
  LISTARDIRECTORIOSFICHEROS: API_URL + '/listardirectoriosficheros',
  CREARDIRECTORIO: API_URL + '/creardirectorio',
  BORRARDIRECTORIO: API_URL + '/borrardirectorio',
  SUBIRFICHERO: API_URL_FORMDATA + '/subirfichero',
  BORRARFICHERO: API_URL + '/borrarfichero',
  BAJARFICHERO: API_URL + '/bajarfichero',
  MERGEDOCX: API_URL + '/mergedocx',

  //INFORMES SQL
  LISTARDIRECTORIOSINFORMES: API_URL + '/listardirectoriosinformes',
  EJECUTARSQL: API_URL + '/ejecutarsql',

  //AMISTOSO
  ACCIONTIPO: API_URL + '/acciontipo',
  COMUNICACIONTIPO: API_URL + '/comunicaciontipo',
  ESTADOS: API_URL + '/estados',
  SUBESTADOS: API_URL + '/subestados',
  EXPEDIENTETIPO: API_URL + '/expedientetipo',
  VARIABLESAMISTOSO: API_URL + '/variablesamistoso',

  //LEGAL
  ACCIONJUDICIALTIPO: API_URL + '/accionjudicialtipo',
  BIENTIPO: API_URL + '/bientipo',
  LETRADO: API_URL + '/letrado',
  OFICIAL: API_URL + '/oficial',
  PROCURADOR: API_URL + '/procurador',
  MOTIVODEV: API_URL + '/motivodev',
  MOTIVOINAD: API_URL + '/motivoinad',
  MOTIVOOPO: API_URL + '/motivoopo',
  ORGANO: API_URL + '/organo',
  PARTIDO: API_URL + '/partido',
  COLEGIOPROFESIONAL: API_URL + '/colegioprofesional',
  PROCEDIMIENTOFASE: API_URL + '/procedimientofase',
  PROCEDIMIENTOESTADO: API_URL + '/procedimientoestado',
  PROCEDIMIENTOSUBESTADO: API_URL + '/procedimientosubestado',
  PROCEDIMIENTOACTUACION: API_URL + '/procedimientoactuacion',
  PROCEDIMIENTOTIPO: API_URL + '/procedimientotipo',
  TIPOINTERVINIENTE: API_URL + '/tipointerviniente',
  VARIABLESJUDICIAL: API_URL + '/variablesjudicial',
  PROCEDIMIENTOORDEN: API_URL + '/procedimientoorden',

  //SEGURIDAD
  PERFIL: API_URL + '/perfil',
  EMPLEADO: API_URL + '/empleado',
  USUARIO: API_URL + '/usuario',
  EMPRESA: API_URL + '/empresa',
  USUARIOPERFILEMPRESA: API_URL + '/usuarioperfilempresa',
  PERFILMENU: API_URL + '/perfilmenu',

  //FACTURACION
  SERIES: API_URL + '/series',
  SERIESDATA: API_URL + '/seriesdata',
  CONCEPTO: API_URL + '/concepto',
  FACTURA: API_URL + '/factura',
  FACTURALINEA: API_URL + '/facturalinea',
  FACTURACONCEPTOTIPO: API_URL + '/facturaconceptotipo',
  FACTURACONCEPTO: API_URL + '/facturaconcepto',
  IMPRIMIRFACTURA: API_URL + '/imprimirfactura',
  MUNICIPIO: API_URL + '/municipio',
  CODIGOPOSTAL: API_URL + '/codigopostal',

  //EVENTOS AGENDA VISTA
  EVENTOTIPO: API_URL + '/eventotipo',
  EVENTO: API_URL + '/evento',
};

//AMISTOSO TABS EXPEIDIENTE
export const API_TABS_EXP: { [key: string]: string } = {
  Accion: API_URL + '/accion',
  Documento: API_URL + '/documento',
  DocuementoDATA: API_URL + '/documentodata',
  MovimientoDeuda: API_URL + '/movimientodeuda',
  Judicial: API_URL + '/procedimientos',
  HistoricoEstado: API_URL + '/historicoexpedienteestado',
  HistoricoSubEstado: API_URL + '/historicoexpedientesubestado',
  HistoricoComunicacion: API_URL + '/historicoexpedientecomunicacion',
  HistoricoGestor: API_URL + '/historicoexpedientegestor',
  FacturaLinea: API_URL + '/facturalinea',
  GenerarFactura: API_URL + '/generarfactura',
  TerceroTelefono: API_URL + '/tercerotelefono',
  TerceroDireccion: API_URL + '/tercerodireccion',
  TerceroMail: API_URL + '/terceroemail',
  Tercero: API_URL + '/tercero',
  Merge: API_URL + '/merge',
};

//LEGAL TABS PROCEDIMIENTO
export const API_TABS_PROC: { [key: string]: string } = {
  Anotacion: API_URL + '/accionjudicial',
  HistoricoProcedimientoActuacion: API_URL + '/historicoprocedimientoactuacion',
  Documento: API_URL + '/documento',
  Judicial: API_URL + '/procedimiento',
  Vinculacion: API_URL + '/vinculacion',
  PreEnvio: API_URL + '/preenvio',
  Bien: API_URL + '/bien',
  TerceroBien: API_URL + '/tercerobien',
  Evento: API_URL + '/evento',
  CerrarTareaManual: API_URL + '/cerrartareamanual',
  AccionJudicialTareaActive: API_URL + '/accionjudicialtareaactive',
};

export const API_PROCU: { [key: string]: string } = {
  AccionJudicialTareaError: API_URL + '/accionjudicialtareaerror',
  Parametros: API_URL + '/parametros',
  ContarTareas: API_URL + '/contartareas',
  AccionJudicialNumPendientesByProcedimiento: API_URL + '/accionjudicialnumpendientesbyproc',
}

export const API_FK: { [key: string]: string } = {
  Pais: API_URL + '/pais',
  Cliente: API_URL + '/cliente',
  Usuario: API_URL + '/usuario',
  Provincia: API_URL + '/provincia',
  PartidoJudicial: API_URL + '/partido',
  Cartera: API_URL + '/cartera/',
  ExpedienteEstado: API_URL + '/estados',
  ExpedienteSubestado: API_URL + '/subestados',
  AccionTipo: API_URL + '/acciontipo',
  Empleado: API_URL + '/empleado',
  Procurador: API_URL + '/procurador',
  OrganoJudicial: API_URL + '/organo',
  Letrado: API_URL + '/letrado',
  ProcedimientoFase: API_URL + '/procedimientofase',
  ProcedimientoEstado: API_URL + '/procedimientoestado',
  ProcedimientoSubestado: API_URL + '/procedimientosubestado',
  ProcedimientoActuacion: API_URL + '/procedimientoactuacion',
  AccionJudicialTipo: API_URL + '/accionjudicialtipo',
  MotivoDevolucion: API_URL + '/motivodev',
  MotivoInadmision: API_URL + '/motivoinad',
  MotivoOposicion: API_URL + '/motivoopo',
  FacturaConceptoTipo: API_URL + '/facturaconceptotipo',
  FacturaConcepto: API_URL + '/facturaconcepto',
  FacturaSerie: API_URL + '/series',
  Tercero: API_URL + '/tercero',
  TerceroTipo: API_URL + '/tercerotipo',
  TerceroTipoJudicial: API_URL + '/tipointerviniente',
  MovimientoDeudaTipo: API_URL + '/movdeudatipo',
  BienTipo: API_URL + '/bientipo',
  ExpedienteComunicacion: API_URL + '/comunicaciontipo',
  DireccionTipo: API_URL + '/direcciontipo',
  TelefonoTipo: API_URL + '/telefonotipo',
  MailTipo: API_URL + '/mailtipo',
  DocumentoTipo: API_URL + '/documentotipo',
  LexDocumentoUnico: API_URL + '/lexdocumentounico',
  ColegioProfesional: API_URL + '/colegioprofesional',
  LexMateria: API_URL + '/lexmateria',
  Municipio: API_URL + '/municipio',
  CodigoPostal: API_URL + '/codigopostal',
  EventoTipo: API_URL + '/eventotipo',
};


//ENDPOINTS PROCESOS
export const PROCESOS: { [key: string]: string } = {
  VALIDARIMPORTACION: API_URL + '/validarimportacion',
  COMPROBARIMPORTACION: API_URL + '/comprobarimportacion',
  IMPORTACION: API_URL + '/importacion',
  VALIDARIMPORTACIONEJECUTADA: API_URL + '/validarimportacionejecutada',
  UPLOADNOTISZIP: API_URL + '/uploadnotiszip',
};

//ENDPOINTS DEALER
export const API_DEALER: { [key: string]: string } = {
  DEMANDA: API_URL + '/enviodemanda',
  ESCRITO: API_URL + '/envioescrito',
  MENSAJELETRADO: API_URL + '/enviomensajeletrado',
  RESPUESTAMENSAJEPROCURADOR: API_URL + '/respuestamensajeprocurador',
  ACCIONDEALER: API_URL + '/acciondealer',
  JUSTIFICANTEDEMANDA: API_URL + '/justificantedemanda',
  JUSTIFICANTEESCRITO: API_URL + '/justificanteescrito',
  RESPUESTAMENSAJELETRADO: API_URL + '/respuestamensajeletrado',
  MENSAJEPROCURADOR: API_URL + '/enviomensajeprocurador',
  MENSAJEPROCURADORERRONEO: API_URL + '/enviomensajeprocuradorerroneo',
  NOTIFICACION: API_URL + '/envionotificacion',
  DEALERACCION: API_URL + '/dealeraccion',
};

export const API_TASKS: { [key: string]: string } = {
  SENDEMAIL: API_URL + '/sendemail',
  SENDSMS: API_URL + '/sendsms',
};

export const API_PRECHECK: { [key: string]: string } = {
  GETNOTINUM: API_URL + '/getnotinum',
  GETNOTINUMENVIO: API_URL + '/getnotinumenvio',
  GETNOTILISTENVIO: API_URL + '/getnotilistenvio',
  GETLISTANOTISTIPO: API_URL + '/getlistanotistipo',
  GETNEXTNOTI: API_URL + '/getnextnoti',
  SETNOTI: API_URL + '/setnoti',
  CAMBIAPROC: API_URL + '/cambiaproc',
  OLVIDANOTI: API_URL + '/olvidanoti',
  GETNOTINUMPREDROPED: API_URL + '/getnotinumpredroped',
  GETNEXTNOTIPREDROPED: API_URL + '/getnextnotipredroped',
  CAMBIARESTADONOTI: API_URL + '/cambiarestadonoti',
};